import { Dialog, DialogBody, DialogContent, DialogSurface, DialogTitle, Text, tokens } from '@fluentui/react-components';
import type { Order } from '../../../models/Order';
import { StatusBadge } from '../../common/StatusBadge';
import { formatDateTime } from '../../../utils/date';

const field = (label: string, value: string | number | null | undefined) => (
  <div style={{ marginBottom: 12 }}>
    <Text size={200} style={{ color: tokens.colorNeutralForeground3, display: 'block', marginBottom: 2 }}>{label}</Text>
    <Text weight="semibold">{value ?? '\u2014'}</Text>
  </div>
);

export const OrderDetailPanel = ({ order, open, onOpenChange }: { order: Order | null; open: boolean; onOpenChange: (open: boolean) => void }) => (
  <Dialog open={open} onOpenChange={(_, data) => onOpenChange(data.open)}>
    <DialogSurface style={{ maxWidth: 640 }}>
      <DialogBody>
        <DialogTitle>{order?.cr_crm_orderreference ?? 'Order details'}</DialogTitle>
        <DialogContent>
          {order ? (
            <>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4px 24px', marginTop: 12 }}>
                {field('Client', order.cr_crm_client?.cr_crm_companyname)}
                <div style={{ marginBottom: 12 }}>
                  <Text size={200} style={{ color: tokens.colorNeutralForeground3, display: 'block', marginBottom: 2 }}>Status</Text>
                  <StatusBadge value={order.cr_crm_status} />
                </div>
                {field('Order date', formatDateTime(order.cr_crm_orderedat ?? undefined))}
                {field('Currency', order.cr_crm_currency)}
                {field('Total USD', order.cr_crm_totalamountusd != null ? `$ ${order.cr_crm_totalamountusd.toFixed(2)}` : null)}
                  {field('Partner Center ID', order.cr_crm_partnercenterorderid)}
                {field('Created', formatDateTime(order.createdon))}
              </div>

              {order.cr_crm_lineitems && order.cr_crm_lineitems.length > 0 && (
                <div style={{ marginTop: 16 }}>
                  <Text weight="semibold" size={400} style={{ display: 'block', marginBottom: 8 }}>Line items</Text>
                  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                    <thead>
                      <tr style={{ borderBottom: `2px solid ${tokens.colorNeutralStroke1}` }}>
                        <th style={{ textAlign: 'left', padding: '6px 8px' }}>Product</th>
                        <th style={{ textAlign: 'center', padding: '6px 8px' }}>Qty</th>
                        <th style={{ textAlign: 'left', padding: '6px 8px' }}>Billing</th>
                      </tr>
                    </thead>
                    <tbody>
                      {order.cr_crm_lineitems.map((li, idx) => (
                        <tr key={idx} style={{ borderBottom: `1px solid ${tokens.colorNeutralStroke2}` }}>
                          <td style={{ padding: '6px 8px' }}>{li.productName || li.skuName || li.skuId}</td>
                          <td style={{ textAlign: 'center', padding: '6px 8px' }}>{li.quantity}</td>
                          <td style={{ padding: '6px 8px' }}>{li.billingCycle || '\u2014'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </>
          ) : null}
        </DialogContent>
      </DialogBody>
    </DialogSurface>
  </Dialog>
);